var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#101010","d":"M19.5 0h-4.9C9.1 0 5.4 3.5 5.4 9.1v4.4H.6a.6.6 0 00-.6.6v6.2a.6.6 0 00.6.6h5v15.6a.6.6 0 00.6.6h6.2a.6.6 0 00.6-.6V20.9h5.8a.6.6 0 00.6-.6v-6.2c0-.3 0-.4-.2-.4l-.4-.2h-5.6V9.8c0-1.6.4-2.5 2.7-2.5h3.4a.6.6 0 00.6-.6V.9c.2-.5 0-.9-.4-.9z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 20 37.1","aria-label":"Facebook"};

module.exports = Facebook;

Facebook.default = Facebook;
